import { padTime } from "../PadString";

const cache: any = {};

export function parseTime(ms: number): string {
    let toSeconds = Math.ceil(Math.abs(ms) / 1000);
    if (!cache[toSeconds]) {
        let sec = toSeconds % 60;
        let min = Math.ceil((toSeconds - sec) / 60);
        cache[toSeconds] = (min > 0 || sec > 10) ? `${padTime(min.toString())}:${padTime(sec.toString())}` : sec.toString();
    }
    return cache[toSeconds];
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./helpers/ParseTime/ParseTime.ts